import { ProductsFilterContainer } from "app/pages/Listing/ProductFilters/ProductsFilterContainer";

export default props => <ProductsFilterContainer {...props} />;
